<template>
    <template v-if="step === 1">
        <div class="px-4">
            <v-form @submit.prevent="nextStep" v-if="calculate">
                <v-row no-gutters class="pt-3">
                    <v-col cols="12" v-if="locale === 'nl'">
                        <div class="text-body-1 font-weight-bold mb-2 text-white">
                            {{ $t('campaign_version_three.How old is your house') }}
                        </div>
                        <v-radio-group color="warning" v-model="form.old_house" inline :rules="[rules.required]" @change="changeOldHouse()">
                            <v-radio :label="$t('campaign_version_three.Older than 10 years')" value="10+" class="opacity-1 text-white"></v-radio>
                            <v-radio :label="$t('campaign_version_three.Younger than 10 years')" value="10-" class="opacity-1 text-white"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12">
                        <div class="text-body-1 font-weight-bold mb-2 text-white">
                            {{ $t('campaign_version_three.What is your annual consumption') }}
                        </div>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model="form.consumption" flat type="number" variant="solo"
                                              density="compact" placeholder="5000" min="0" :rules="[rules.required, rules.minKwh]">
                                    <template v-slot:append-inner>
                                        <div class="text-primary font-weight-bold text-body-2">
                                            {{ $t('campaign_version_three.kWh_year') }}
                                        </div>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <div class="text-body-1 font-weight-bold mb-2 text-white">
                            {{ $t('campaign_version_three.What is your roof type') }}
                        </div>
                        <v-radio-group color="warning" v-model="pvOffer.$data.offerBasis.roof_sheathing" inline :rules="[rules.required]">
                            <v-radio v-for="roofSheathing in roofSheathings" :label="roofSheathing.name"
                                     :value="roofSheathing.id"
                                     class="opacity-1 flex-1-1 text-white"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12">
                        <v-btn block color="warning" size="large" type="submit"
                               class="rounded-pill font-weight-bold btn-calculate-font text-transform-none py-6">
                            {{ $t('campaign_version_three.Calculate my price') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
            <v-btn v-else block @click="openCalculate" color="warning" size="large"
                   class="rounded-pill font-weight-bold btn-calculate-font text-transform-none py-6">
                {{ $t('campaign_version_three.Get a free quote') }}
            </v-btn>
            <div class="text-body-2 text-white font-weight-medium text-center py-5">
                {{ $t('campaign_version_three.quote_review') }}
            </div>
            <v-row no-gutters="" justify="center">
                <v-col cols="4" class="text-center">
                    <v-rating class="mb-1" color="warning" density="compact" model-value="5" readonly half-increments
                              size="small"></v-rating>
                    <div class="text-body-2 text-white font-weight-bold pt-3 pb-6 " style="white-space: nowrap;">-- {{ $t('campaign_version_three.quote_review_name') }}</div>
                </v-col>
            </v-row>
        </div>
    </template>
    <template v-if="step === 2">
        <v-form @submit.prevent="send" class="pt-3">
            <div id="ready-header" :class="$vuetify.display.smAndDown?'text-h6':'text-h5 f-s-22'" class="text-white font-weight-bold">{{ $t('campaign_version_three.Your Estimate is ready') }}</div>
            <div class="d-flex justify-space-between text-white py-3" v-if="locale === 'pl'">
                <div class="text-body-1">
                    <span class="font-weight-bold">{{ $t('campaign_version_three.Installation size:') }}</span>
                </div>
                <div class="text-body-1">{{ pvOffer.installationSize() }} kWp</div>
            </div>
            <v-divider color="rgba(255, 255, 255, 0.4)" v-if="locale === 'pl'"></v-divider>
            <div class="d-flex justify-space-between text-white py-3">
                <div class="text-body-1"><span class="font-weight-bold">{{ pvOffer.$data.solarPanelSelected.brand }}</span> {{ pvOffer.$data.solarPanelSelected.model }}
                    <v-tooltip location="right">
                        <template v-slot:activator="{ props }">
                            <v-icon
                                v-bind="props"
                                class="pl-2"
                                size="16"
                                icon="mdi-information-slab-circle-outline"></v-icon>
                        </template>
                        <span>{{$t('campaign_version_three.Solar panel tooltip', {productWarranty: pvOffer.$data.solarPanelSelected.product_warranty_years, yieldWarranty:pvOffer.$data.solarPanelSelected.yield_warranty_years})}}</span>
                    </v-tooltip>
                </div>
                <div class="text-body-1">{{ pvOffer.$data.pvSolarPanelsNumber }}</div>
            </div>
            <v-divider color="rgba(255, 255, 255, 0.4)"></v-divider>
            <div class="d-flex justify-space-between text-white py-3">
                <div class="text-body-1"><span class="font-weight-bold">{{ pvOffer.$data.inverterSelected.brand }}</span> {{ pvOffer.$data.inverterSelected.is_hybrid ? $t('campaign_version_three.Hybrid') : '' }} {{ $t('campaign_version_three.inverter') }}
                    <v-tooltip location="right">
                        <template v-slot:activator="{ props }">
                            <v-icon
                                v-bind="props"
                                class="pl-2"
                                size="16"
                                icon="mdi-information-slab-circle-outline"></v-icon>
                        </template>
                        <span>{{`${pvOffer.$data.inverterSelected.brand} ${pvOffer.$data.inverterSelected.model}` }}</span>
                    </v-tooltip>
                </div>



                <div class="text-body-1">{{ pvOffer.$data.inverterQuantity }}</div>
            </div>
            <v-divider color="rgba(255, 255, 255, 0.4)"></v-divider>
            <div class="d-flex justify-space-between text-white py-3">
                <div class="text-body-1">{{ $t('campaign_version_three.Installation material') }}</div>
                <div class="text-body-1">{{ $t('campaign_version_three.Included') }}</div>
            </div>
            <v-divider color="rgba(255, 255, 255, 0.4)"></v-divider>
            <div class="d-flex justify-space-between text-white py-3">
                <div class="text-body-1">{{ $t('campaign_version_three.Inspection and admin') }}</div>
                <div class="text-body-1">{{ $t('campaign_version_three.Included') }}</div>
            </div>
            <v-divider color="rgba(255, 255, 255, 0.4)"></v-divider>
            <div class="text-white align-center pt-1 pb-8">
                <div class="d-flex justify-space-between">
                    <v-switch :label="$t('campaign_version_three.Battery')" v-model="form.battery" hide-details inset color="success" @click="toggleBattery"
                              density="compact" class="custom_switch"></v-switch>
                    <div v-if="!form.battery" class="text-body-1">{{ $t('campaign_version_three.None') }}</div>
                    <v-btn-toggle
                        v-if="form.battery"
                        v-model="form.batterykWh"
                        @click="onBatteryChange"
                        rounded="lg"
                        density="compact"
                        variant="outlined"
                        color="white"
                        class="custom-border-color"
                        selected-class="bg-white text-primary font-weight-bold"
                        divided
                        mandatory="force"
                    >
<!--                        @click="onBatteryChange"-->
                        <v-btn class="text-body-2 cursor-pointer" v-for="kwh in availableBatterySizes" :value="kwh"> {{parseInt(kwh)}} kWh</v-btn>
                    </v-btn-toggle>
                </div>
                <div class="pt-2">
                    <div v-if="form.battery" class="text-caption text-white font-italic">
                        {{ $t('campaign_version_three.Based on your installation size', {pvSize: pvOffer.installationSize(), batSize: Math.round(pvOffer.installationSize()*1.5)}) }}
                    </div>
                </div>
            </div>
            <v-row justify="center" no-gutters>
                <v-col cols="10">
                    <div class="bg-prices text-center rounded-lg py-6 mb-5">
                        <p>
                            <span class="text-h4 font-weight-bold text-white mr-5">{{ formattedPrice }}</span>
                            <span class="text-body-1 text-decoration-line-through text-price-old">{{ formattedPriceBefore }}</span>
                        </p>
                        <p class="text-white" v-if="locale === 'pl'">Brutto</p>
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="text-body-1 font-weight-bold mb-2 text-white f-s-22">{{
                            $t('campaign_version_three.Email')
                        }}
                    </div>
                    <v-text-field v-model="form.email" variant="solo" type="email"
                                  :placeholder="$t('campaign_version_three.Email placeholder')"
                                  :rules="[rules.required, rules.email]"></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-btn block color="warning" type="submit" size="large"
                           class="rounded-pill font-weight-bold btn-calculate-font text-transform-none py-6">
                        {{ $t('campaign_version_three.Send me my detailed offer') }}
                    </v-btn>
                </v-col>
                <v-col cols="4" class="mb-3 mt-5">
                    <v-btn color="white" variant="text" class="text-transform-none align-center text-body-1"
                           @click="prevStep" prepend-icon="mdi-arrow-left">{{ $t('campaign_version_three.Go back') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <v-overlay
            :model-value="overlay"
            class="align-center justify-center"
        >
            <v-progress-circular
                v-if="formInProgress"
                color="primary"
                indeterminate
                size="64"
            ></v-progress-circular>
            <v-card v-else>
                <v-card-text class="text-xl" id="lp3-thank-you">
                    {{ $t('campaign_version_three.Thank you message') }}
                </v-card-text>
            </v-card>
        </v-overlay>
    </template>
<!--    <template v-if="step === 3">-->
<!--        <div :class="$vuetify.display.smAndDown?'text-h6':'text-h5 f-s-22'" class="text-white font-weight-bold">-->
<!--            {{ $t('campaign_version_three.Enter your details') }}-->
<!--        </div>-->
<!--        <v-list lines="two" bg-color="transparent" density="compact">-->
<!--            <v-list-item class="px-0 py-3 custom-list-item">-->
<!--                <template v-slot:prepend>-->
<!--                    <v-icon color="success" icon="mdi-check" size="x-small" class="mr-2 opacity-1"></v-icon>-->
<!--                </template>-->
<!--                <v-list-item-subtitle class="text-body-1 opacity-1 text-white"-->
<!--                                      v-html="$t('campaign_version_three.We will send you a detailed quote')"></v-list-item-subtitle>-->
<!--            </v-list-item>-->
<!--            <v-list-item class="px-0 py-3 custom-list-item">-->
<!--                <template v-slot:prepend>-->
<!--                    <v-icon color="success" icon="mdi-check" size="x-small" class="mr-2 opacity-1"></v-icon>-->
<!--                </template>-->
<!--                <v-list-item-subtitle class="text-body-1 opacity-1 text-white"-->
<!--                                      v-html="$t('campaign_version_three.We will contact you for a non-binding technical inspection')"></v-list-item-subtitle>-->
<!--            </v-list-item>-->
<!--            <v-list-item class="px-0 py-3 custom-list-item">-->
<!--                <template v-slot:prepend>-->
<!--                    <v-icon color="success" icon="mdi-check" size="x-small" class="mr-2 opacity-1"></v-icon>-->
<!--                </template>-->
<!--                <v-list-item-subtitle class="text-body-1 opacity-1 text-white"-->
<!--                                      v-html="$t('campaign_version_three.Installation within 6 weeks after signing the offer')"></v-list-item-subtitle>-->
<!--            </v-list-item>-->
<!--        </v-list>-->
<!--        <v-form class="pt-10 pb-16" @submit.prevent="send">-->
<!--            <v-row>-->
<!--                <v-col cols="6" class="py-0">-->
<!--                    <div class="text-body-1 font-weight-bold mb-2 text-white">{{-->
<!--                            $t('campaign_version_three.First name')-->
<!--                        }}-->
<!--                    </div>-->
<!--                    <v-text-field v-model="form.first_name" variant="solo"-->
<!--                                  :placeholder="$t('campaign_version_three.First name placeholder')"-->
<!--                                  :rules="[rules.required]"></v-text-field>-->
<!--                </v-col>-->
<!--                <v-col cols="6" class="py-0">-->
<!--                    <div class="text-body-1 font-weight-bold mb-2 text-white">{{-->
<!--                            $t('campaign_version_three.Last name')-->
<!--                        }}-->
<!--                    </div>-->
<!--                    <v-text-field v-model="form.last_name" variant="solo"-->
<!--                                  :placeholder="$t('campaign_version_three.Last name placeholder')"-->
<!--                                  :rules="[rules.required]"></v-text-field>-->
<!--                </v-col>-->
<!--                <v-col cols="6" class="py-0">-->
<!--                    <div class="text-body-1 font-weight-bold mb-2 text-white">{{-->
<!--                            $t('campaign_version_three.Email')-->
<!--                        }}-->
<!--                    </div>-->
<!--                    <v-text-field v-model="form.email" variant="solo" type="email"-->
<!--                                  :placeholder="$t('campaign_version_three.Email placeholder')"-->
<!--                                  :rules="[rules.required, rules.email]"></v-text-field>-->
<!--                </v-col>-->
<!--                <v-col cols="6" class="py-0">-->
<!--                    <div class="text-body-1 font-weight-bold mb-2 text-white">{{-->
<!--                            $t('campaign_version_three.Phone')-->
<!--                        }}-->
<!--                    </div>-->
<!--                    <v-text-field v-model="form.phone" variant="solo"-->
<!--                                  :placeholder="$t('campaign_version_three.Phone placeholder')"-->
<!--                                  :rules="[rules.required,rules.phone]"></v-text-field>-->
<!--                </v-col>-->
<!--                <v-col cols="12" class="py-0">-->
<!--                    <div class="text-body-1 font-weight-bold mb-2 text-white">{{-->
<!--                            $t('campaign_version_three.Address')-->
<!--                        }}-->
<!--                    </div>-->
<!--                    <v-text-field v-model="form.address" variant="solo"-->
<!--                                  :placeholder="$t('campaign_version_three.Address placeholder')"-->
<!--                                  :rules="[rules.required]"></v-text-field>-->
<!--                </v-col>-->
<!--                <v-col cols="12" class="py-0">-->
<!--                    <v-btn color="warning" size="large" block-->
<!--                           class="py-6 btn-calculate-font font-weight-bold text-transform-none rounded-pill"-->
<!--                           type="submit">{{ $t('campaign_version_three.Send my offer') }}-->
<!--                    </v-btn>-->
<!--                </v-col>-->
<!--            </v-row>-->
<!--        </v-form>-->
<!--        <v-overlay-->
<!--            :model-value="overlay"-->
<!--            class="align-center justify-center"-->
<!--        >-->
<!--            <v-progress-circular-->
<!--                v-if="formInProgress"-->
<!--                color="primary"-->
<!--                indeterminate-->
<!--                size="64"-->
<!--            ></v-progress-circular>-->
<!--            <v-card v-else>-->
<!--                <v-card-text class="text-xl" id="lp3-thank-you">-->
<!--                    {{ $t('campaign_version_three.Thank you message') }}-->
<!--                </v-card-text>-->
<!--            </v-card>-->
<!--        </v-overlay>-->
<!--    </template>-->
</template>

<script>

import {
    isValidPhoneNumber,
} from 'libphonenumber-js'

import PvOfferModel from "@/models/PvOfferModel";
import {reactive} from "vue";
import {th} from "vuetify/locale";
import _ from "lodash";

export default {
    name: "CalculatorStepper",
    props: {
        locale: {
            type: String,
            required: true,
        },
        roofSheathings: {
            type: Array,
            required: true,
        },
        allSolarPanels: {
            type: Array,
            required: true,
        },
        allInverters: {
            type: Array,
            required: true,
        },
        allBatteries: {
            type: Array,
            required: true,
        },
        priceFactors: {
            type: Array,
            required: true,
        },
        minimumCompanyMargins: {
            type: Array,
            required: true,
        },
        baseMargins: {
            type: Array,
            required: true,
        },
        solarPanelId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            calculate: false,
            minimumKwh: this.locale === 'pl' ? 4000 : 0,
            step: 1,
            rules: {
                required: value => !!value || this.$t('validation.required', {attribute: ''}),
                email: value => !value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) || this.$t('referrers.E-mail must be valid'),
                // phone: value => !value || isValidPhoneNumber(value, this.locale.toUpperCase()) || this.$t('validation.contactPhone', {attribute: this.$t('validation.attributes.phone')}),
                minKwh: value => (value && value >= this.minimumKwh) || this.$t('validation.minimumKwh', {attribute: this.minimumKwh}),
            },
            overlay: false,
            formInProgress: true,
        };
    },
    setup(props) {
        const form = reactive({
            // first_name: '',
            // last_name: '',
            email: '',
            // phone: '',
            // address: '',
            old_house: '',
            consumption: '',
            roof: '',
            battery: false,
            batterykWh: null,
        })

        const offerBasis = reactive({
            roof_sheathing: null,
            lightning_protection: false,
            grounding: false,
            digging: false,
            digging_length: 0,
            lift: false,
            stuck_tiles: false,
            snow_guards: false,
            lightning_rod_removal: false,
            insurance: false,
            imageUpload: null,
            clientName: null,
            clientAddress: null,
            pdId: null,
            vat_level: (props.locale && props.locale === 'pl') ? 1.08 : 1.06,
        })

        let subsidy
        if (props.locale === 'nl' && form.old_house === '10+') {
            subsidy = 'be_base'
        } else {
            subsidy = false;
        }

        const pvOffer = new PvOfferModel({
            defaultSolarPanelId: props.solarPanelId,
            defaultInverterId: null,
            roofSheathings: props.roofSheathings,
            priceFactors: props.priceFactors,
            userExtraPremium: 0,
            offerBasis: offerBasis,
            samplePvOfferIndex: 1,
            allBatteries: props.allBatteries,
            allSolarPanels: props.allSolarPanels,
            allInverters: props.allInverters,
            minimumCompanyMargins: props.minimumCompanyMargins,
            baseMargins: props.baseMargins,
            annualConsumption: form.consumption,
            dynamicConsumptionMode: true,
            subsidy: subsidy,
            enablePowerOptimizers: false,
            powerOptimizersAuto: true,
            groundMounted: false,
            discount: 0,
            autoFillOptimizers: true
        });

        pvOffer.$data.offerBasis.roof_sheathing = null;

        return {pvOffer, offerBasis, form}
    },
    computed: {
        formattedPrice() {
            this.pvOffer.$data.annualConsumption = this.form.consumption;
            return this.$numberHelper.formatMoneyAsString(this.pvOffer.ownInvestmentTotal())
        },
        formattedPriceBefore() {
            const price = this.pvOffer.ownInvestmentTotal() * 1.1
            return this.$numberHelper.formatMoneyAsString(price)
        },
        vatPercentage() {
            return (this.offerBasis.vat_level - 1) * 100;
        },
        availableBatterySizes() {
            let batteryKwh = _.map(this.allBatteries, 'kwh');
            let integerArray = _.sortBy(_.map(batteryKwh, function(num) { return parseFloat(num); }))
            return integerArray;
        }
    },
    methods: {
        openCalculate() {
            this.calculate = true;
        },
        async nextStep(e) {
            e.preventDefault();
            e.stopPropagation();
            let res = await e;
            if (!res.valid) return;

            this.step += 1;
        },
        prevStep() {
            this.step -= 1;
        },
        changeOldHouse() {
            let subsidy = false

            if (this.form.old_house === '10+') {
                subsidy = 'be_base'
            }

            this.pvOffer.applySubsidy(subsidy)
        },
        toggleBattery() {
            if(this.form.batterykWh === null) {
                this.form.batterykWh = this.availableBatterySizes[1];
                this.onBatteryChange();
            }  else {
                this.form.batterykWh = null;
                this.onBatteryChange();
            }
        },
        onBatteryChange() {
            const batterySize = this.form.batterykWh;
            const foundBattery = _.find(this.allBatteries, function(o) {
                return parseFloat(o.kwh) === parseFloat(batterySize);
            });
            // debugger;
            this.pvOffer.changeBattery(foundBattery);
        },
        async send(e) {
            e.preventDefault();
            e.stopPropagation();

            this.overlay = true

            axios.post(
                this.route("lp-one-submit-offer"),
                {
                    first_name: 'Unknown', //this.form.first_name,
                    last_name: 'Unknown', //this.form.last_name,
                    email: this.form.email,
                    phone: 'Unknown', //this.form.phone,
                    address: 'Unknown', //this.form.address,
                    old_house: this.form.old_house,
                    consumption: this.form.consumption,
                    roof: this.form.roof,
                    battery: this.form.battery,
                    offer: this.pvOffer.finalOfferData()
                }
            ).then((response) => {
                if (response.data.success) {
                    this.formInProgress = false
                }
            });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'lp3-submitted'
            });
        }
    }
}
</script>

<style>
.btn-calculate-font {
    font-size: 18px;
    color: #433500 !important;
}

.opacity-1 {
    opacity: 1;
}

.v-radio.opacity-1 .v-label {
    opacity: 1;
}

.bg-prices {
    background: #152687;
}

.text-price-old {
    color: #8391E0;
}

.custom_switch.v-switch--inset .v-switch__track {
    height: 20px;
    width: 38px;
    background: #101D62;
}

.custom_switch.v-switch--inset .text-success .v-switch__track {
    background: #1EB26D;
    opacity: 1;
}

.custom_switch.v-switch .v-selection-control__input {
    width: 14px;
    height: 14px;
}

.custom_switch.v-switch .v-selection-control__input .v-switch__thumb {
    width: 14px;
    height: 14px;
    background-color: #ffffff;
}

.custom-border-color {
    border-color: rgba(255, 255, 255, 0.4);
    color: rgba(255, 255, 255, 0.5);
}
</style>
